const FCM_STORAGE_KEYS = {
  TOKEN: 'fcmToken',
  TOKEN_CONFIG_SIGNATURE: 'fcmTokenConfigSignature',
  SERVER_SYNC_ID: 'fcmTokenServerSyncId',
  SESSION_BOOTSTRAPPED: 'fcmSessionBootstrapped',
};

const tiers = {
  local: {
    get(key) {
      try {
        return localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    remove(key) {
      try {
        localStorage.removeItem(key);
      } catch {
        // Safari private mode / storage disabled
      }
    },
  },
  session: {
    get(key) {
      try {
        return sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        sessionStorage.setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    remove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch {
        // ignore
      }
    },
  },
};

const safeGet = (key) => tiers.local.get(key) ?? tiers.session.get(key);

const safeSet = (key, value) => tiers.local.set(key, value) || tiers.session.set(key, value);

const safeRemove = (key) => {
  tiers.local.remove(key);
  tiers.session.remove(key);
};

export const buildFcmServerSyncId = (token, configSignature) =>
  `${configSignature}:${token}`;

export const getStoredFcmTokens = () => ({
  localToken: safeGet(FCM_STORAGE_KEYS.TOKEN),
  tokenConfigSignature: safeGet(FCM_STORAGE_KEYS.TOKEN_CONFIG_SIGNATURE),
  serverSyncId: safeGet(FCM_STORAGE_KEYS.SERVER_SYNC_ID),
});

export const clearStoredFcmTokens = () => {
  safeRemove(FCM_STORAGE_KEYS.TOKEN);
  safeRemove(FCM_STORAGE_KEYS.TOKEN_CONFIG_SIGNATURE);
  safeRemove(FCM_STORAGE_KEYS.SERVER_SYNC_ID);
  tiers.session.remove(FCM_STORAGE_KEYS.SESSION_BOOTSTRAPPED);
};

export const isFcmSessionBootstrapped = () => {
  try {
    return tiers.session.get(FCM_STORAGE_KEYS.SESSION_BOOTSTRAPPED) === '1';
  } catch {
    return false;
  }
};

export const markFcmSessionBootstrapped = () => {
  tiers.session.set(FCM_STORAGE_KEYS.SESSION_BOOTSTRAPPED, '1');
};

export const saveLocalTokenIfChanged = (prevToken, nextToken, getCurrentConfigSignature) => {
  if (prevToken !== nextToken) {
    safeSet(FCM_STORAGE_KEYS.TOKEN, nextToken);
  }
  safeSet(FCM_STORAGE_KEYS.TOKEN_CONFIG_SIGNATURE, getCurrentConfigSignature());
};

export const saveFcmServerSyncId = (syncId) => {
  if (typeof syncId === 'string' && syncId) {
    safeSet(FCM_STORAGE_KEYS.SERVER_SYNC_ID, syncId);
  }
};
